export { Skeleton, type SkeletonProps } from './skeleton';
export { SkeletonTextBlock, type SkeletonTextBlockProps } from './skeleton-text';
